
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/short-internships/[short-internship-id]",
      function () {
        return require("private-next-pages/next/short-internships/[short-internship-id].tsx");
      }
    ]);
  